import { Box, Center, Loader } from "@mantine/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import PageTitle from "../../components/Page/PageTitle";
import PageWrapper from "../../components/Page/PageWrapper";
import { clearAuditTrail } from "../../redux/features/auditTrail/auditTrailSlice";
import { errorMsg } from "../../utils/vars";
import AuditTrailActions from "./components/AuditTrailActions";
import AuditTrailChart from "./components/AuditTrailChart";
import AuditTrailCriteria from "./components/AuditTrailCriteria";
import { useDropdownDataQuery } from "./components/useAuditTrailQueries";
import classes from "./auditTrail.module.scss";
import { useTranslation } from "react-i18next";

const AuditTrail = () => {
  const dispatch = useDispatch();
  const { isLoading, error } = useDropdownDataQuery();
  const { t } = useTranslation();

  useEffect(() => {
    if (error) toast.error(error?.response?.data?.message || errorMsg);
  }, [error]);

  useEffect(() => {
    return () => {
      dispatch(clearAuditTrail());
    };
  }, [dispatch]);

  if (isLoading) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.auditTrail")} />
        <Center h={300}>
          <Loader />
        </Center>
      </PageWrapper>
    );
  }

  if (error) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.auditTrail")} />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.auditTrail")} />
      <Box className={classes.toolbar}>
        <AuditTrailActions />
      </Box>
      <AuditTrailCriteria />
      <AuditTrailChart />
    </PageWrapper>
  );
};

export default AuditTrail;
